import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ExpenseTracker from '../components/ExpenseTracker';
import '../styles/Admin.css';

const AdminExpenses = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }

  return (
    <div className="admin-page-wrapper">
      <div className="admin-container">
        {/* Header */}
        <div className="admin-header">
          <div className="admin-header-content">
            <div className="admin-nav-links">
              <Link to="/" className="admin-logo-link">
                <img src="/cadence-gold-plate.png" alt="CADENCE" className="admin-logo" />
              </Link>
              <div className="admin-breadcrumb">
                <Link to="/admin" className="admin-back-link">
                  <ArrowLeft size={16} /> Dashboard
                </Link>
              </div>
            </div>
            <h1>Expense Tracker</h1>
            <p className="admin-subtitle">
              Track and manage startup costs
            </p>
          </div>
        </div>

        {/* Full Expense Tracker */}
        <div className="admin-card">
          <ExpenseTracker />
        </div>
      </div>
    </div>
  );
};

export default AdminExpenses;
